function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "glow",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter3"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter4"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter4",
  result: "shadowBlurOuter4",
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter4",
  result: "shadowMatrixOuter4",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter5"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter5",
  result: "shadowBlurOuter5",
  stdDeviation: 0
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter5",
  result: "shadowMatrixOuter5",
  values: "0 0 0 0 0.27 0 0 0 0 1 0 0 0 0 0.27 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feMerge", {
  result: "merge-0"
}, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter4"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter5"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "path",
  id: "boulder-r",
  filter: "url(#glow)",
  d: "M442.693,12.806c2.146-2.145,2.789-5.371,1.629-8.174C443.162,1.828,440.426,0,437.392,0H38.408 c-3.034,0-5.77,1.828-6.93,4.631c-1.16,2.804-0.518,6.03,1.629,8.174L215.4,194.928v223.035l-73.506,43.898 c-2.896,1.73-4.281,5.181-3.384,8.434c0.896,3.252,3.855,5.505,7.229,5.505h184.32c3.374,0,6.333-2.253,7.229-5.505 c0.897-3.252-0.487-6.704-3.384-8.434L260.4,417.963V194.928L442.693,12.806z M302.874,460.8H172.926l53.819-32.141 c2.267-1.354,3.654-3.799,3.654-6.439v-222.9h1.2c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-5.596L56.526,15h362.748 L247.6,186.513c-0.176,0.176-0.342,0.36-0.5,0.552c-0.068,0.082-0.126,0.169-0.189,0.253c-0.083,0.111-0.169,0.22-0.246,0.335 c-0.071,0.106-0.133,0.216-0.198,0.325c-0.061,0.101-0.124,0.2-0.18,0.304c-0.061,0.113-0.112,0.23-0.166,0.345 c-0.05,0.106-0.103,0.21-0.148,0.319c-0.047,0.114-0.086,0.231-0.127,0.347c-0.041,0.115-0.085,0.229-0.121,0.346 c-0.035,0.116-0.061,0.234-0.09,0.352c-0.03,0.12-0.064,0.238-0.088,0.36c-0.027,0.137-0.043,0.275-0.063,0.412 c-0.015,0.105-0.035,0.207-0.045,0.313c-0.024,0.247-0.037,0.494-0.037,0.742c0,0,0,0,0,0v230.4c0,2.64,1.388,5.085,3.654,6.439 L302.874,460.8z M247.485,152.855c-2.866-2.991-2.765-7.739,0.227-10.604l16.267-15.586c2.99-2.866,7.738-2.763,10.604,0.227 c2.866,2.991,2.765,7.739-0.227,10.604l-16.267,15.586c-1.453,1.393-3.322,2.084-5.188,2.084 C250.927,155.166,248.958,154.392,247.485,152.855z M289.399,112.692c-2.866-2.991-2.765-7.738,0.227-10.604l73.809-70.724 c2.99-2.866,7.739-2.764,10.604,0.227c2.866,2.991,2.765,7.738-0.227,10.604l-73.809,70.723c-1.453,1.393-3.322,2.085-5.188,2.085 C292.841,115.003,290.872,114.229,289.399,112.692z"
});

function SvgMartiniGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475.8 475.8",
    style: {
      enableBackground: "new 0 0 475.8 475.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartiniGlass);
export default __webpack_public_path__ + "static/media/martini-glass.65e6344a.svg";
export { ForwardRef as ReactComponent };